import supabase from '../lib/supabaseClient';

const TABLE='review_links_1700000000002';
const makeSlug=(name)=> name.normalize('NFKD').replace(/[\u0300-\u036f]/g,'').toLowerCase().replace(/[^a-z0-9]+/g,'-').replace(/^-|-$/g,'').slice(0,65) || 'local-business';
const reserved=new Set(['reviews','pricing','results','marketing','privacy','terms','cw']);

function check(error) {
  if (error) throw new Error(error.message);
}

export async function listReviewLinks() {
  const {data,error}=await supabase.from(TABLE).select('*').order('created_at',{ascending: false});
  check(error);
  return data || [];
}

export async function getReviewLink(slug) {
  const {data,error}=await supabase.from(TABLE).select('*').eq('slug',slug).maybeSingle();
  check(error);
  return data;
}

export async function createReviewLink(business) {
  if (!business.placeId || !business.name) {
    throw new Error('Please select a Google business before creating a link.');
  }
  const rows=await listReviewLinks();
  const base=makeSlug(business.name);
  let slug=base;
  let suffix=2;
  while (reserved.has(slug) || rows.some((row)=> row.slug===slug)) {
    slug=`${base}-${suffix++}`;
  }
  const record={
    slug,
    place_id: business.placeId,
    business_name: business.name,
    address: business.address || '',
    image_url: business.imageUrl || '',
    maps_url: business.mapsUrl || ''
  };
  const {data,error}=await supabase.from(TABLE).insert(record).select().single();
  check(error);
  return data;
}

export async function updateReviewLink(id,changes) {
  const name=String(changes.business_name || '').trim();
  if (!name) throw new Error('Business name is required.');
  const record={
    business_name: name,
    address: String(changes.address || '').trim(),
    image_url: String(changes.image_url || '').trim(),
    maps_url: String(changes.maps_url || '').trim(),
    updated_at: new Date().toISOString()
  };
  if (record.image_url && !/^data:image\/jpeg;base64,[A-Za-z0-9+/=]+$/.test(record.image_url)) {
    try {
      if (!['http:','https:'].includes(new URL(record.image_url).protocol)) throw new Error();
    } catch {
      throw new Error('Image link must be a valid HTTP or HTTPS URL.');
    }
  }
  if (record.maps_url) {
    try {
      if (!['http:','https:'].includes(new URL(record.maps_url).protocol)) throw new Error();
    } catch {
      throw new Error('Google Maps link must be a valid HTTP or HTTPS URL.');
    }
  }
  const {data,error}=await supabase.from(TABLE).update(record).eq('id',id).select().single();
  check(error);
  return data;
}